import { render } from "./ListeCategorieAbonnePage.vue?vue&type=template&id=3ca1c5f4&ts=true"
import script from "./ListeCategorieAbonnePage.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieAbonnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__